import { Link } from 'react-router-dom';

// Prose strings in the content data files may contain "[anchor text](/route)" to
// place a genuine contextual internal link, or "[anchor text](https://…)" to cite an
// external source. Strings without that markup render exactly as before, so this is
// safe to apply to any existing copy.
export function withInlineLinks(text, className) {
  if (typeof text !== 'string') return text;
  const pattern = /\[([^\]]+)\]\(([^)]+)\)/g;
  if (!pattern.test(text)) return text;
  pattern.lastIndex = 0;

  const cls = className || 'font-bold text-steel underline underline-offset-4 hover:text-navy transition-colors';
  const nodes = [];
  let last = 0;
  let match;
  let i = 0;
  while ((match = pattern.exec(text))) {
    if (match.index > last) nodes.push(text.slice(last, match.index));
    const href = match[2];
    nodes.push(
      // External sources leave the app as ordinary links; internal routes stay client-side.
      /^https?:\/\//.test(href) ? (
        <a key={i++} href={href} rel="noopener noreferrer" className={cls}>
          {match[1]}
        </a>
      ) : (
        <Link key={i++} to={href} className={cls}>
          {match[1]}
        </Link>
      )
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}
